import { ChangeEvent } from "react";

import { Card, Grid, Autocomplete, Switch } from "@mui/material";
import { FormikErrors, FormikTouched } from "formik";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { OPTIONEXIBIRINSCRITO, OPTIONTIPOINSCRICAO } from "helpers/constants";

import formCadastroEvento from "../schemas/forms";
import FormField from "./EventoFormField";
import { StatusEvento } from "interfaces/typesystem";

const { formField } = formCadastroEvento;
const { limiteInscricao, groupInsc, exibirListInscrito, statusId } = formField;

interface FieldDetailsProps {
  checkedDestaque: boolean;
  listStatusEvento: StatusEvento[];
  isEdit?: boolean;
  errors: FormikErrors<Record<string, string>>;
  touched: FormikTouched<Record<string, string>>;
  values: {
    [x: string]: string;
  };
  handleBlur: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  handleChange: {
    (e: ChangeEvent<any>): void;
    <T = string | ChangeEvent<any>>(
      field: T
    ): T extends ChangeEvent<any>
      ? void
      : (e: string | ChangeEvent<any>) => void;
  };
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  setFieldTouched: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean
  ) => void;
  handlerExibirDestaque: (
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => void;
}
export default function FieldDetails({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
  setFieldTouched,
  handlerExibirDestaque,
  checkedDestaque,
  listStatusEvento,
  isEdit,
}: FieldDetailsProps) {
  return (
    <Card id="details" sx={{ overflow: "visible", margin: "10px 0" }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Limites e tipo evento</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Informe o limite geral de atletas inscritos e especifique se o evento
          será individual ou em grupo.
        </MDTypography>
      </MDBox>

      <MDBox pb={3} px={3}>
        <Grid container spacing={3} sx={{ py: 1 }}>
          <Grid item xs={12} sm={isEdit ? 3 : 6}>
            <FormField
              variant="outlined"
              name={limiteInscricao.name}
              type={limiteInscricao.type}
              label={limiteInscricao.label}
              value={values.limiteInscricao}
              required
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(
                touched.limiteInscricao && errors.limiteInscricao
              )}
              helperText={
                touched.limiteInscricao && errors.limiteInscricao
                  ? String(errors.limiteInscricao)
                  : undefined
              }
              inputProps={{ min: 1, step: 1 }}
              sx={{ background: "white" }}
            />

            <MDTypography
              variant="caption"
              display="block"
              gutterBottom
              sx={{ mt: 1 }}
            >
              Informe a quantidade limite de atletas para se inscrever no evento
            </MDTypography>
          </Grid>

          <Grid item xs={12} sm={isEdit ? 4 : 6}>
            <Autocomplete
              value={
                OPTIONTIPOINSCRICAO.find(
                  (item) => item.value === String(values.groupInsc)
                ) || null
              }
              options={OPTIONTIPOINSCRICAO}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              onChange={(_event, value) =>
                setFieldValue(groupInsc.name, value?.value || "")
              }
              onBlur={() => setFieldTouched(groupInsc.name, true)}
              renderInput={(params) => (
                <FormField
                  {...params}
                  bindFormik={false}
                  variant="outlined"
                  name={groupInsc.name}
                  required
                  label={groupInsc.label}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
            <MDTypography
              variant="caption"
              display="block"
              gutterBottom
              sx={{ mt: 1 }}
            >
              Informar o tipo de inscrição individual ou grupos
            </MDTypography>
          </Grid>

          {isEdit && (
            <Grid item xs={12} sm={5}>
              <Autocomplete
                value={
                  listStatusEvento.find(
                    (item) => String(item.id) === String(values.statusId)
                  ) || null
                }
                options={listStatusEvento}
                getOptionLabel={(option) => option.tipo}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disabled={
                  listStatusEvento.find(
                    (item) => String(item.id) === String(values.statusId)
                  )?.tipo === "Processamento"
                }
                onChange={(_event, value) =>
                  setFieldValue(statusId.name, value ? String(value.id) : "")
                }
                onBlur={() => setFieldTouched(statusId.name, true)}
                renderInput={(params) => (
                  <FormField
                    {...params}
                    bindFormik={false}
                    variant="outlined"
                    name={statusId.name}
                    required
                    label={statusId.label}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
              <MDTypography
                variant="caption"
                display="block"
                gutterBottom
                sx={{ mt: 1 }}
              >
                Para publicar evento é necessário informar o lotes,
                distâncias/Categorias e tipo de Pagamento
              </MDTypography>
            </Grid>
          )}
        </Grid>

        <MDTypography
          variant="caption"
          fontWeight="bold"
          color="text"
          textTransform="uppercase"
        >
          CARD
        </MDTypography>

        <Grid container spacing={3} sx={{ py: 1 }}>
          <Grid item xs={12} sm={6}>
            <MDBox display="flex" alignItems="center" mb={2} sx={{ py: 1 }}>
              <MDBox mt={0.5}>
                <Switch
                  checked={checkedDestaque}
                  onChange={() => handlerExibirDestaque(setFieldValue)}
                  color="info"
                />
              </MDBox>
              <MDBox width="80%" ml={0.5}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  Exibir evento em destaque?
                </MDTypography>
                <MDTypography variant="caption" display="block" color="text">
                  Quando ativado, o evento será exibido em destaque na página
                  inicial e em locais prioritários do site.
                </MDTypography>
              </MDBox>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autocomplete
              value={
                OPTIONEXIBIRINSCRITO.find(
                  (item) => item.value === values.exibirListInscrito
                ) || null
              }
              options={OPTIONEXIBIRINSCRITO}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              onChange={(_event, value) =>
                setFieldValue(exibirListInscrito.name, value?.value || "")
              }
              onBlur={() => setFieldTouched(exibirListInscrito.name, true)}
              renderInput={(params) => (
                <FormField
                  {...params}
                  bindFormik={false}
                  name={exibirListInscrito.name}
                  required
                  label={exibirListInscrito.label}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
